import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { MapPin, Globe, Building } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const ViewInstitutionProfile = () => {
    const { id } = useParams();
    const [institution, setInstitution] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchInstitution = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/institutionfilter/getPublicInst/${id}`);
                setInstitution(response.data.data);
            } catch (err) {
                console.error("Error fetching institution:", err);
                setError('Failed to load institution details.');
            } finally {
                setLoading(false);
            }
        };
        fetchInstitution();
    }, [id]);

    if (loading) return <div className="text-center py-20">Loading...</div>;
    if (error) return <div className="text-center py-20 text-red-500">{error}</div>;
    if (!institution) return <div className="text-center py-20">Institution not found.</div>;

    return (
        <div className="bg-gray-50 min-h-screen flex flex-col">
            <Navbar />

            <main className="flex-grow container mx-auto px-4 py-8">
                <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-md overflow-hidden">
                    {/* Header / Banner area (could be added) */}

                    <div className="p-8">
                        <div className="flex flex-col md:flex-row items-start justify-between">
                            <div>
                                <h1 className="text-3xl font-bold text-gray-900">{institution.name}</h1>
                                <div className="flex items-center mt-2 text-gray-600">
                                    <MapPin size={18} className="mr-2" />
                                    <span>
                                        {institution.address?.area}, {institution.address?.city}, {institution.address?.state}
                                    </span>
                                </div>
                            </div>
                            <div className="mt-4 md:mt-0 px-4 py-2 bg-blue-50 text-blue-700 rounded-full text-sm font-semibold">
                                {institution.type}
                            </div>
                        </div>

                        <hr className="my-6 border-gray-100" />

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900 mb-4">About Institution</h3>
                                <p className="text-gray-700 leading-relaxed">
                                    {institution.description || "No description provided."}
                                </p>
                            </div>

                            <div className="space-y-4">
                                <h3 className="text-lg font-semibold text-gray-900 mb-4">Contact & Details</h3>

                                {institution.website && (
                                    <div className="flex items-center text-gray-700">
                                        <Globe size={18} className="mr-3 text-gray-400" />
                                        <a href={institution.website} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                                            {institution.website}
                                        </a>
                                    </div>
                                )}

                                <div className="flex items-center text-gray-700">
                                    <Building size={18} className="mr-3 text-gray-400" />
                                    <span>{institution.ownership || "Ownership not specified"}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default ViewInstitutionProfile;
